<template>
  <v-alert
    v-if="bannerMessage && !isAdmin"
    type="warning"
    variant="tonal"
    class="maintenance-banner mx-4 my-2"
    :closable="false"
  >
    <span>{{ bannerMessage }}</span>
    <span v-if="scheduledEnd">
      &nbsp;Expected to resume at {{ formatUtc(scheduledEnd) }} ({{ formatLocal(scheduledEnd) }}).
    </span>
  </v-alert>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import store from '@/store';

const bannerMessage = computed<string | null>(() => store.getters['maintenance/bannerMessage']);
const scheduledEnd = computed<string | null>(() => store.getters['maintenance/scheduledEnd']);
const isAdmin = computed<boolean>(() => store.getters['login/isAdmin']);

function formatUtc(iso: string): string {
  return `${new Date(iso).toLocaleString('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })} UTC`;
}

function formatLocal(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  });
}
</script>
